window.addEventListener('DOMContentLoaded', () => {
  const { parseAttribute } = window.Rocketify

  const productForm = document.querySelector('product-form')
  const variantPicker = document.querySelector('variant-picker')

  const productTitle = document.querySelector('h1.product-title')
  const productDescription = document.querySelector('.main-product-description')
  const tailleCoupe = document.querySelector(
    '.disclosure__content[data-title="Taille & Coupe"]'
  )
  const guideTailles = document.querySelector(
    '.disclosure__content[data-title="Guide des tailles"]'
  )
  const compoEntretien = document.querySelector(
    '.disclosure__content[data-title="Composition & Entretien"]'
  )
  const collectionImage1 = document.querySelector(
    '[data-product-description="image-1"]'
  )
  const collectionImage2 = document.querySelector(
    '[data-product-description="image-2"]'
  )
  const collectionTitle = document.querySelector('[data-collection-title]')
  const collectionContent = document.querySelector('[data-collection-content]')

  const [
    allTitreVariante,
    allDescriptionVariante,
    allTailleCoupeVariante,
    allGuideTaillesVariante,
    allCompositionEntretienVariante,
    allCollectionDescriptionVariante,
    allCollectionTitreVariante,
    allCollectionImage1Variante,
    allCollectionImage2Variante,
    allThemeLabelVariante,
  ] = [
    parseAttribute(productForm.getAttribute('data-all-titre-variante')),
    parseAttribute(productForm.getAttribute('data-all-description-variante')),
    parseAttribute(productForm.getAttribute('data-all-taille-coupe-variante')),
    parseAttribute(productForm.getAttribute('data-all-guide-tailles-variante')),
    parseAttribute(
      productForm.getAttribute('data-all-composition-entretien-variante')
    ),
    parseAttribute(
      productForm.getAttribute('data-all-collection-description-variante')
    ),
    parseAttribute(
      productForm.getAttribute('data-all-collection-titre-variante')
    ),
    parseAttribute(
      productForm.getAttribute('data-all-collection-image-1-variante')
    ),
    parseAttribute(
      productForm.getAttribute('data-all-collection-image-2-variante')
    ),
    parseAttribute(productForm.getAttribute('data-all-theme-label-variante')),
  ]

  const updateView = () => {
    const variant = variantPicker.getSelectedVariant()

    const [
      variantTitle,
      variantDescription,
      varianteTailleCoupe,
      varianteGuideTailles,
      varianteComposition,
      varianteCollectionDescription,
      varianteCollectionTitre,
      varianteCollectionImage1,
      varianteCollectionImage2,
      varianteThemeLabel,
    ] = [
      allTitreVariante.find(({ variantId }) => variantId === variant.id),
      allDescriptionVariante.find(({ variantId }) => variantId === variant.id),
      allTailleCoupeVariante.find(({ variantId }) => variantId === variant.id),
      allGuideTaillesVariante.find(({ variantId }) => variantId === variant.id),
      allCompositionEntretienVariante.find(
        ({ variantId }) => variantId === variant.id
      ),
      allCollectionDescriptionVariante.find(
        ({ variantId }) => variantId === variant.id
      ),
      allCollectionTitreVariante.find(
        ({ variantId }) => variantId === variant.id
      ),
      allCollectionImage1Variante.find(
        ({ variantId }) => variantId === variant.id
      ),
      allCollectionImage2Variante.find(
        ({ variantId }) => variantId === variant.id
      ),
      allThemeLabelVariante.find(({ variantId }) => variantId === variant.id),
    ]

    if (variantTitle) {
      productTitle.innerText = variantTitle.value
    } else {
      productTitle.innerText = productTitle.getAttribute('data-original-value')
    }

    if (variantDescription) {
      productDescription.innerHTML = variantDescription.value
        .split('\n')
        .map((v) => `<p>${v}</p>`)
        .join(' ')
    } else {
      productDescription.innerHTML = productDescription.getAttribute(
        'data-original-value'
      )
    }

    if (varianteTailleCoupe) {
      tailleCoupe.innerHTML = varianteTailleCoupe.value
        .split('\n')
        .map((v) => `<p>${v}</p>`)
        .join(' ')
    } else {
      tailleCoupe.innerHTML = tailleCoupe.getAttribute('data-original-value')
    }

    if (varianteGuideTailles) {
      guideTailles.innerHTML = varianteGuideTailles.value
    } else {
      guideTailles.innerHTML = guideTailles.getAttribute('data-original-value')
    }

    if (varianteComposition) {
      compoEntretien.innerHTML = varianteComposition.value
        .split('\n')
        .map((v) => `<p>${v}</p>`)
        .join(' ')
    } else {
      compoEntretien.innerHTML = compoEntretien.getAttribute(
        'data-original-value'
      )
    }

    if (collectionContent) {
      if (varianteCollectionDescription) {
        collectionContent.innerHTML = varianteCollectionDescription.value
          .split('\n')
          .map((v) => `<p>${v}</p>`)
          .join(' ')
      } else {
        collectionContent.innerHTML = collectionContent.getAttribute(
          'data-original-value'
        )
      }
    }

    if (collectionTitle) {
      if (varianteCollectionTitre) {
        collectionTitle.innerHTML = varianteCollectionTitre.value
      } else {
        collectionTitle.innerHTML = collectionTitle.getAttribute(
          'data-original-value'
        )
      }
    }

    const img1 = collectionImage1?.querySelector('img')
    const img2 = collectionImage2?.querySelector('img')

    if (img1) {
      if (varianteCollectionImage1 && collectionImage1) {
        img1.src = varianteCollectionImage1.value
        img1.srcset = varianteCollectionImage1.value
      } else {
        img1.src = collectionImage1.getAttribute('data-original-value')
        img1.srcset = collectionImage1.getAttribute('data-original-value')
      }
    }

    if (img2) {
      if (varianteCollectionImage2 && collectionImage2) {
        img2.src = varianteCollectionImage2.value
        img2.srcset = varianteCollectionImage2.value
      } else {
        img2.src = collectionImage2.getAttribute('data-original-value')
        img2.srcset = collectionImage2.getAttribute('data-original-value')
      }
    }

    const label = document.querySelector('.product-label')
    const labelSpan = label?.querySelector('span')
    const originalLabel = label?.getAttribute('data-original-value')

    if (labelSpan) {
      if (varianteThemeLabel) {
        labelSpan.style.display = 'block'
        labelSpan.innerText = varianteThemeLabel.value
      } else if (originalLabel) {
        labelSpan.style.display = 'block'
        labelSpan.innerText = originalLabel
      } else {
        labelSpan.style.display = 'none'
        labelSpan.innerText = ''
      }
    }
  }

  document.addEventListener('on:variant:change', () => {
    updateView()
  })

  updateView()
})
